import appRoutes from '../app-routes'

export enum MAIN_MENU_KEYS {
	DASHBOARD = 1,
	WALLETS,
	TRANSACTIONS,
	REPORTS,
	CLIENTS,
	SETTINGS,
	LOGOUT,
	ORGANIZATION,
	HELP,
	INVITE_CPA,
}

export const URL_KEY_MAP = {
	[appRoutes.dashboard()]: MAIN_MENU_KEYS.DASHBOARD,
	[appRoutes.integrations.list()]: MAIN_MENU_KEYS.WALLETS,
	[appRoutes.transactions.list()]: MAIN_MENU_KEYS.TRANSACTIONS,
	[appRoutes.reports.list()]: MAIN_MENU_KEYS.REPORTS,
	[appRoutes.clients.list()]: MAIN_MENU_KEYS.CLIENTS,
	[appRoutes.organization()]: MAIN_MENU_KEYS.ORGANIZATION,
}
